import { __awaiter } from "tslib";
import ApiManager from '@/managers/apimanagers';
import { ref } from 'vue';
export const useStakingHistory = () => {
    const isLoading = ref(false);
    const isPostFaild = ref(false);
    // /**
    //  * @summary history transact
    //  * @param history transact
    //  */
    // const getStakingHistory = async (id?: number): Promise<StakingHistoryModel> => {
    //   try {
    //     isLoading.value = true;
    //     const query = id ? `?memberID=${id}` : '';
    //     return await ApiManager.get<StakingHistoryModel>('/crypto-staking-funds-history' + query);
    //   } catch (err) {
    //     isPostFaild.value = true;
    //     throw err;
    //   } finally {
    //     isLoading.value = false;
    //   }
    // };
    /**
     * @returns list paginate
     */
    const getStakingHistory = (id, stakingId, check, from, limit) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const url = `/crypto-staking-funds-history?memberID=${id}&stakingId=${stakingId}&check=${check}&offset=${from}&limit=${limit}`;
            return yield ApiManager.get(url);
        }
        catch (err) {
            throw err;
        }
    });
    /**
     * @returns count
     */
    const getStakingHistoryCount = (id, stakingId, check) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const url = `/crypto-staking-funds-history-count?memberID=${id}&stakingId=${stakingId}&check=${check}`;
            return yield ApiManager.get(url);
        }
        catch (err) {
            throw err;
        }
    });
    return { isPostFaild, isLoading, getStakingHistory, getStakingHistoryCount };
};
